module.exports = __webpack_public_path__ + "img/canbadge_gokaku_60mm.f1dcbc00.png";